import { getFormValues } from 'redux-form';
import { ApplicationState } from '@mews-commander/types';

interface Props {
    form: string;
}
export const formValuesSelector = <FormData extends {}>(state: ApplicationState, { form }: Props) =>
    getFormValues(form)(state) as FormData;
